export default "__VITE_ASSET__f0dc558c__"